import React, { useEffect, useState } from 'react'
import { Segment, Icon } from 'semantic-ui-react'

const messageStyles = {
  position: 'fixed',
  top: '3vh',
  left: '2.5%',
  width: '95%',
  zIndex: '999999',
  textAlign: 'center',
  boxShadow: '0 0 25px 0 rgba(0,0,0,.5)',
}

const Connection = () => {
  const [online, setOnline] = useState(true)

  useEffect(() => {
    const goOffline = () => {
      setOnline(false)
    }
    const goOnline = () => {
      setOnline(true)
    }

    window.addEventListener('offline', goOffline)
    window.addEventListener('online', goOnline)

    return () => {
      window.removeEventListener('offline', goOffline)
      window.removeEventListener('online', goOnline)
    }
  }, [])

  if (online) return null

  return (
    <Segment style={messageStyles} inverted color='red'>
      <Icon name='exclamation triangle' />
      No internet connection detected. Please connect to the internet before
      attempting to access the app. 23424
    </Segment>
  )
}

export default Connection
